import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from './components/LoginPage.vue';
import DatamanagementArea from './views/DatamanagementArea.vue';
import DashboardPage from '@/features/dashboard/pages/DashboardPage.vue';
import MarketingLayout from '@/features/marketing/pages/MarketingLayout.vue';
import MarketingOverviewPage from '@/features/marketing/pages/MarketingOverviewPage.vue';
import EmailDashboardPage from '@/features/marketing/pages/EmailDashboardPage.vue';
import DigitalDashboardPage from '@/features/marketing/pages/DigitalDashboardPage.vue';
import SocialDashboardPage from '@/features/marketing/pages/SocialDashboardPage.vue';
import TrafficDashboardPage from '@/features/marketing/pages/TrafficDashboardPage.vue';
import PrintDashboardPage from '@/features/marketing/pages/PrintDashboardPage.vue';
import axios from 'axios';
import { getApiBaseUrl } from '@/config';

const routes = [
  { path: '/', component: LoginPage, name: 'Login' },
  { path: '/dashboard', component: DashboardPage, meta: { requiresAuth: true, module: 'financial' }, name: 'dashboard' },
  { path: '/datamanagement', component: DatamanagementArea, meta: { requiresAuth: true }, name: 'datamanagementarea' },
  {
    path: '/marketing',
    component: MarketingLayout,
    meta: { requiresAuth: true, module: 'marketing' },
    children: [
      { path: '', name: 'marketing-overview', component: MarketingOverviewPage },
      { path: 'email', name: 'marketing-email', component: EmailDashboardPage },
      { path: 'digital', name: 'marketing-digital', component: DigitalDashboardPage },
      { path: 'social', name: 'marketing-social', component: SocialDashboardPage },
      { path: 'traffic', name: 'marketing-traffic', component: TrafficDashboardPage },
      { path: 'print', name: 'marketing-print', component: PrintDashboardPage }
    ]
  },
  { path: '/digitaldashboard', redirect: '/dashboard' },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

const apiUrl = getApiBaseUrl();

function hasModule(data, moduleName) {
  if (data.user_role === 'admin') return true;
  return Array.isArray(data.access_modules) && data.access_modules.includes(moduleName);
}

router.beforeEach(async (to, from, next) => {
  if (to.path === '/') {
    next();
    return;
  }
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next();
    return;
  }
  try {
    const response = await axios.get(`${apiUrl}/current_user/`, { withCredentials: true });
    if (!response.data.is_authenticated) {
      next('/');
      return;
    }
    const canFinancial = hasModule(response.data, 'financial');
    const canMarketing = hasModule(response.data, 'marketing');
    if (to.meta.module === 'marketing' && !canMarketing) {
      next({ name: canFinancial ? 'dashboard' : 'Login' });
      return;
    }
    if (to.meta.module === 'financial' && !canFinancial) {
      next({ name: canMarketing ? 'marketing-overview' : 'Login' });
      return;
    }
    next();
  } catch (error) {
    next('/');
  }
});

export default router;
